// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"12\" viewBox=\"0 0 13 12\" fill=\"none\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.1465 3.64648L10.8536 4.35359L6.50004 8.70714L2.14648 4.35359L2.85359 3.64648L6.50004 7.29293L10.1465 3.64648Z\" fill=\"black\"/> </svg> ";
// Exports
module.exports = code;